module.exports = __webpack_public_path__ + "static/media/KW13_pijler AS2.23a9f8a0.JPG";